import { render } from "./MenuHamburguer.vue?vue&type=template&id=48667158&scoped=true&ts=true"
import script from "./MenuHamburguer.vue?vue&type=script&lang=ts"
export * from "./MenuHamburguer.vue?vue&type=script&lang=ts"

import "./MenuHamburguer.vue?vue&type=style&index=0&id=48667158&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48667158"]])

export default __exports__